import React, { FunctionComponent, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import Add from '../Manage/Add/Add'
import Manage from '../Manage/Manage'
import Update from '../Manage/Update/Update'
import Overview from '../Overview/Overview'
import { getPersonTargets } from '../Store/Actions'

const Bootstrap: FunctionComponent = () => {
  const dispatch = useDispatch()

  const { user, targets, errors } = useAppSelector(state => ({
    user: state.users.currentUser,
    targets: state.hr.personTargets.list,
    errors: state.hr.personTargets.errors,
  }))

  useEffect(() => {
    if (!targets || !user) {
      dispatch(getPersonTargets())
    }
  }, [])

  if (!user) return <Spinner />

  if (!user || typeof targets === 'undefined') return <Spinner />

  if (!user || !targets) {
    return <p>You don't have the required permissions to view this page</p>
  }

  return (
    <div>
      <Switch>
        <Route
          path="/hr/targets/manage/add"
          render={() => <Add errors={errors} />}
        />
        <Route
          path="/hr/targets/manage/:targetId/update"
          render={() => <Update targets={targets} />}
        />
        <Route
          path="/hr/targets/manage"
          render={() => <Manage targets={targets} />}
        />
        <Route path="/hr/targets" render={() => <Overview />} />
      </Switch>
    </div>
  )
}

export default Bootstrap
